module.exports = __webpack_public_path__ + "80ffe19ac962eb7a1b845f377c11a242.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/fonts/td-icons.woff2
 ** module id = 25
 ** module chunks = 0
 **/